export const API_USER = "api/users"
export const API_ROLES = "api/roles"

export const SUCCESS_GET_CUITS = 'SUCCESS_GET_CUITS'
export const FAILED_GET_CUITS = 'FAILED_GET_CUITS'
export const ERROR_GET_CUITS = 'ERROR_GET_CUITS'

export const SUCCESS_GET_REEMBOLSO = 'SUCCESS_GET_REEMBOLSO'
export const FAILED_GET_REEMBOLSO = 'FAILED_GET_REEMBOLSO'
export const ERROR_GET_REEMBOLSO = 'ERROR_GET_REEMBOLSO'

export const SUCCESS_GET_EMPRESARIAL = 'SUCCESS_GET_EMPRESARIAL'
export const FAILED_GET_EMPRESARIAL = 'FAILED_GET_EMPRESARIAL'
export const ERROR_GET_EMPRESARIAL = 'ERROR_GET_EMPRESARIAL'

export const SUCCESS_OBTENER_TyC = 'SUCCESS_OBTENER_TyC'
export const FAILED_OBTENER_TyC = 'FAILED_OBTENER_TyC'
export const ERROR_OBTENER_TyC = 'ERROR_OBTENER_TyC'

export const SUCCESS_ACEPTAR_TyC = 'SUCCESS_ACEPTAR_TyC'
export const FAILED_ACEPTAR_TyC = 'FAILED_ACEPTAR_TyC'
export const ERROR_ACEPTAR_TyC = 'ERROR_ACEPTAR_TyC'

export const SUCCESS_SET_SOLICITUD = 'SUCCESS_SET_SOLICITUD'
export const FAILED_SET_SOLICITUD = 'FAILED_SET_SOLICITUD'
export const ERROR_SET_SOLICITUD = 'ERROR_SET_SOLICITUD'

export const SUCCESS_POST_DISPONIBLE_POR_CUIT = 'SUCCESS_POST_DISPONIBLE_POR_CUIT'
export const FAILED_POST_DISPONIBLE_POR_CUIT = 'FAILED_POST_DISPONIBLE_POR_CUIT'
export const ERROR_POST_DISPONIBLE_POR_CUIT = 'ERROR_POST_DISPONIBLE_POR_CUIT'

export const SUCCESS_POST_ADELANTAR = 'SUCCESS_POST_ADELANTAR'
export const FAILED_POST_ADELANTAR = 'FAILED_POST_ADELANTAR'
export const ERROR_POST_ADELANTAR = 'ERROR_POST_ADELANTAR'

export const SUCCESS_LISTA_REEMBOLSO = 'SUCCESS_LISTA_REEMBOLSO'
export const FAILED_LISTA_REEMBOLSO = 'FAILED_LISTA_REEMBOLSO'
export const ERROR_LISTA_REEMBOLSO = 'ERROR_LISTA_REEMBOLSO'

export const SUCCESS_SET_USUARIO = 'SUCCESS_SET_USUARIO'
export const FAILED_SET_USUARIO = 'FAILED_SET_USUARIO'
export const ERROR_SET_USUARIO = 'ERROR_SET_USUARIO'

export const MEDIO_DE_PAGO_DIGITAL = 0 
export const MEDIO_DE_PAGO_TRANSFERENCIA = 1 